// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/features/';
export const actions = [
  'SET_PRODUCT_FEATURES_FOR_FIELD',
  'SET_PRODUCT_FEATURES_FOR_ALL_FIELDS',
  'SET_ELIGIBLE_PRODUCTS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = { 
    byUuid: {},
    eligibleProducts: {},
    isEligibleProductsFetchCompleted: false
  },
  action = {}
) {
  switch (action.type) {
    case actions.SET_PRODUCT_FEATURES_FOR_FIELD:
      return {
        ...state,
        byUuid: {
          ...state.byUuid,
          [action.payload.fieldUuid]: action.payload.features
        }
      };
    case actions.SET_PRODUCT_FEATURES_FOR_ALL_FIELDS:
      return {
        ...state,
        byUuid: {
          ...state.byUuid,
          ...action.payload.features
        }
      };
    case actions.SET_ELIGIBLE_PRODUCTS:
      return {
        ...state,
        eligibleProducts: action.payload.eligibleProducts,
        isEligibleProductsFetchCompleted: true
      };
    default:
      return state;
  }
}

// Action Creators

export const setProductFeaturesByFieldUuid = ({fieldUuid, features}) => {
  return {
    type: actions.SET_PRODUCT_FEATURES_FOR_FIELD,
    payload: {fieldUuid, features}
  };
};

export const setEligibleProducts = ({ eligibleProducts }) => {
  return {
    type: actions.SET_ELIGIBLE_PRODUCTS,
    payload: { eligibleProducts }
  };
};
